import React, { useRef, useState, useEffect } from 'react';
import { CustomLoader } from "../Services/CommonLibrary"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CommunicationAudioV1 from './CommunicationAudiov1';
import CommunicationTextPatients from './CommunicationTextPatients';
import CommunicationTextV1 from './CommunicationTextv1';

function Communicationv1() {
    const [key, setKey] = useState('audio');
    const [loading, setLoading] = useState(false);
    const isTestUser = localStorage.getItem('isTestUser');

    return (
        <>
            <section className='projects-section uploadtab call-communications'>
                <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)} className="mb-1">
                    <Tab eventKey="audio" title="Call communications">
                        <CommunicationAudioV1 />
                    </Tab>
                    <Tab eventKey="text" title="Text communications">
                        <CommunicationTextV1 />
                    </Tab>

                </Tabs>

            </section>

            {loading ? <CustomLoader /> : null}
        </>
    );
}
export default Communicationv1;